import * as tslib_1 from "tslib";
import * as esriLoader from 'esri-loader';
import { Interceptor } from './classes/interceptor';
import { LayerExtender } from './classes/mclayer';
import { MapExtender } from './classes/mcmap';
import { MapViewExtender } from './classes/mcMapView';
var ESRI = /** @class */ (function () {
    function ESRI() {
    }
    ESRI.loadModules = function () {
        var modules = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            modules[_i] = arguments[_i];
        }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Interceptor.addInterceptor()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, esriLoader.loadModules(modules, window.esriConfig)];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Object.defineProperty(ESRI, "esriStylesUrl", {
        get: function () { return esriLoader.loadCss(window.esriConfig.version).href; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "AreaMeasurement2D", {
        // Start Getters
        /**
         * Get ESRI AreaMeasurement2D ['esri/widgets/AreaMeasurement2D']
         */
        get: function () { return this.getter('esri/widgets/AreaMeasurement2D'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "AreaMeasurement2DViewModel", {
        /**
         * Get ESRI AreaMeasurement2DViewModel ['esri/widgets/AreaMeasurement2D/AreaMeasurement2DViewModel']
         */
        get: function () { return this.getter('esri/widgets/AreaMeasurement2D/AreaMeasurement2DViewModel'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "Basemap", {
        /**
         * Get ESRI Basemap ['esri/Basemap']
         */
        get: function () { return this.getter('esri/Basemap'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "BingMapsLayer", {
        /**
         * Get ESRI Bing Maps Layer ['esri/layers/BingMapsLayer']
         */
        get: function () { return this.getter('esri/layers/BingMapsLayer'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "BasemapGallery", {
        /**
         * Get ESRI BasemapGallery ['esri/widgets/BasemapGallery']
         */
        get: function () { return this.getter('esri/widgets/BasemapGallery'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "Config", {
        /**
         * Get ESRI Map ['esri/config']
         */
        get: function () { return this.getter('esri/config'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "Draw", {
        /**
         * Get ESRI Draw ['esri/views/draw/Draw']
         */
        get: function () { return this.getter('esri/views/draw/Draw'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "DistanceMeasurement2D", {
        /**
         * Get ESRI DistanceMeasurement2D ['esri/widgets/DistanceMeasurement2D']
         */
        get: function () { return this.getter('esri/widgets/DistanceMeasurement2D'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "DistanceMeasurement2DViewModel", {
        /**
         * Get ESRI DistanceMeasurement2DViewModel ['esri/widgets/DistanceMeasurement2D/DistanceMeasurement2DViewModel']
         */
        get: function () { return this.getter('esri/widgets/DistanceMeasurement2D/DistanceMeasurement2DViewModel'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "Expand", {
        /**
         * Get ESRI Expand ['esri/widgets/Expand']
         */
        get: function () { return this.getter('esri/widgets/Expand'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "Extent", {
        /**
         * Get ESRI Extent ['esri/geometry/Extent']
         */
        get: function () { return this.getter('esri/geometry/Extent'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "FeatureLayer", {
        /**
         * Get ESRI Featurelayer ['esri/layers/FeatureLayer']
         */
        get: function () { return this.getter('esri/layers/FeatureLayer'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "GeometryEngine", {
        /**
         * Get ESRI Geometry Engine ['esri/geometry/geometryEngine']
         */
        get: function () { return this.getter('esri/geometry/geometryEngine'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "GeometryEngineAsync", {
        /**
         * Get ESRI Geometry Engine Async ['esri/geometry/geometryEngineAsync']
         */
        get: function () { return this.getter('esri/geometry/geometryEngineAsync'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "GeometryService", {
        /**
         * Get ESRI GeometryService ['esri/tasks/GeometryService']
         */
        get: function () { return this.getter('esri/tasks/GeometryService'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "AreasAndLengthsParameters", {
        /**
         * Get ESRI AreasAndLengthsParameters ['esri/rest/support/AreasAndLengthsParameters']
         */
        get: function () { return this.getter('esri/rest/support/AreasAndLengthsParameters'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "LengthsParameters", {
        /**
         * Get ESRI LengthsParameters ['esri/rest/support/LengthsParameters']
         */
        get: function () { return this.getter('esri/rest/support/LengthsParameters'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "Query", {
        /**
         * Get ESRI QueryTask ['eesri/tasks/support/Query']
         */
        get: function () { return this.getter('esri/tasks/support/Query'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "QueryTask", {
        /**
         * Get ESRI QueryTask ['esri/tasks/QueryTask']
         */
        get: function () { return this.getter('esri/tasks/QueryTask'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "Geoprocessor", {
        /**
         * Get ESRI Geoprocessor ['esri/tasks/Geoprocessor']
         */
        get: function () { return this.getter('esri/tasks/Geoprocessor'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "Graphic", {
        /**
         * Get ESRI Graphic ['esri/Graphic']
         */
        get: function () { return this.getter('esri/Graphic'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "GraphicsLayer", {
        /**
         * Get ESRI GraphicsLayer ['esri/layers/GraphicsLayer']
         */
        get: function () { return this.getter('esri/layers/GraphicsLayer'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "Point", {
        /**
         * Get ESRI Point ['esri/geometry/Point']
         */
        get: function () { return this.getter('esri/geometry/Point'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "Multipoint", {
        /**
         * Get ESRI Multipoint ['esri/geometry/Multipoint']
         */
        get: function () { return this.getter('esri/geometry/Multipoint'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "Polyline", {
        /**
         * Get ESRI Polyline ['esri/geometry/Polyline']
         */
        get: function () { return this.getter('esri/geometry/Polyline'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "Sketch", {
        /**
         * Get ESRI Sketch Widget ['esri/widgets/Sketch']
         */
        get: function () { return this.getter('esri/widgets/Sketch'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "SketchViewModel", {
        /**
         * Get ESRI Sketch Widget ['esri/widgets/Sketch/SketchViewModel']
         */
        get: function () { return this.getter('esri/widgets/Sketch/SketchViewModel'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "MapImageLayer", {
        /**
         * Get ESRI MapImagelayer ['esri/layers/MapImageLayer']
         */
        get: function () { return this.getter('esri/layers/MapImageLayer'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "Request", {
        /**
         * Get ESRI Request ['esri/request']
         */
        get: function () { return this.getter('esri/request'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "urlUtils", {
        /**
         * Get ESRI Request ['esri/core/urlUtils']
         */
        get: function () { return this.getter('esri/core/urlUtils'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "route", {
        /**
         * Get ESRI Request ['esri/rest/route']
         */
        get: function () { return this.getter('esri/rest/route'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "RouteParameters", {
        /**
         * Get ESRI Request ['esri/rest/support/RouteParameters']
         */
        get: function () { return this.getter('esri/rest/support/RouteParameters'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "ProjectParameters", {
        /**
         * Get ESRI Project Paramters ['esri/tasks/support/ProjectParameters']
         */
        get: function () { return this.getter('esri/tasks/support/ProjectParameters'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "FeatureSet", {
        /**
         * Get ESRI Request ['esri/rest/support/FeatureSet']
         */
        get: function () { return this.getter('esri/rest/support/FeatureSet'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "SimpleRenderer", {
        /**
         * Get ESRI SimpleRenderer ['esri/renderers/SimpleRenderer']
         */
        get: function () { return this.getter('esri/renderers/SimpleRenderer'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "HeatmapRenderer", {
        /**
         * Get ESRI HeatmapRenderer ['esri/renderers/HeatmapRenderer']
         */
        get: function () { return this.getter('esri/renderers/HeatmapRenderer'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "SpatialReference", {
        /**
         * Get ESRI SpatialReference ['esri/geometry/SpatialReference']
         */
        get: function () { return this.getter('esri/geometry/SpatialReference'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "Sublayer", {
        /**
         * Get ESRI Sublayer ['esri/layers/support/Sublayer']
         */
        get: function () { return this.getter('esri/layers/support/Sublayer'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "GroupLayer", {
        /**
         * Get ESRI Sublayer ['esri/layers/GroupLayer']
         */
        get: function () { return this.getter('esri/layers/GroupLayer'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "SimpleMarkerSymbol", {
        /**
         * Get ESRI SimpleMarkerSymbol ['esri/symbols/SimpleMarkerSymbol']
         */
        get: function () { return this.getter('esri/symbols/SimpleMarkerSymbol'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "IdentifyTask", {
        /**
         * Get ESRI IdentifyTask ['esri/rest/identify']
         */
        get: function () { return this.getter('esri/rest/identify'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "IdentifyParameters", {
        /**
         * Get ESRI IdentifyParameters ['esri/rest/support/IdentifyParameters']
         */
        get: function () { return this.getter('esri/rest/support/IdentifyParameters'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "Popup", {
        /**
         * Get ESRI Popup ['esri/widgets/Popup']
         */
        get: function () { return this.getter('esri/widgets/Popup'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "PopupTemplate", {
        /**
         * Get ESRI PopupTemplate ['esri/PopupTemplate']
         */
        get: function () { return this.getter('esri/PopupTemplate'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "WebTileLayer", {
        /**
         * Get ESRI WebTileLayer ['esri/layers/WebTileLayer']
         */
        get: function () { return this.getter('esri/layers/WebTileLayer'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "TileLayer", {
        /**
         * Get ESRI TileLayer ['esri/layers/TileLayer']
         */
        get: function () { return this.getter('esri/layers/TileLayer'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "Polygon", {
        /**
         * Get ESRI Polygon ['esri/geometry/Polygon']
         */
        get: function () { return this.getter('esri/geometry/Polygon'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "Circle", {
        /**
         * Get ESRI Circle ['esri/geometry/Circle']
         */
        get: function () { return this.getter('esri/geometry/Circle'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "WebMercatorUtils", {
        /**
         * Get ESRI WebMercatorUtils ['esri/geometry/webMercatorUtils']
         */
        get: function () { return this.getter('esri/geometry/support/webMercatorUtils'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "Color", {
        /**
         * Get ESRI color ['esri/Color']
         */
        get: function () { return this.getter('esri/Color'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "SymbologyColor", {
        /**
         * Get ESRI color ['esri/smartMapping/symbology/color']
         */
        get: function () { return this.getter('esri/smartMapping/symbology/color'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "Histogram", {
        /**
         * Get ESRI histogram ['esri/smartMapping/statistics/histogram']
         */
        get: function () { return this.getter('esri/smartMapping/statistics/histogram'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "ClassedColorSlider", {
        /**
         * Get ESRI Classed color slider ['esri/widgets/smartMapping/ClassedColorSlider']
         */
        get: function () { return this.getter('esri/widgets/smartMapping/ClassedColorSlider'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "ClassBreaksRenderer", {
        /**
         * Get ESRI Class breaks renderer ['esri/renderers/ClassBreaksRenderer']
         */
        get: function () { return this.getter('esri/renderers/ClassBreaksRenderer'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "UniqueValueRenderer", {
        /**
         * Get ESRI Unique value renderer ['esri/renderers/UniqueValueRenderer']
         */
        get: function () { return this.getter('esri/renderers/UniqueValueRenderer'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "VisualVariable", {
        /**
         * Get ESRI VisualVariable object['esri/renderers/visualVariables/VisualVariable]
         */
        get: function () { return this.getter('esri/renderers/visualVariables/VisualVariable'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "SimpleMarker", {
        /**
         * Get simple marker symbol ['esri/symbols/simpleMarker']
         */
        get: function () { return this.getter('esri/symbols/SimpleMarkerSymbol'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "PictureMarker", {
        /**
         * Get picture marker symbol ['esri/symbols/pictureMarker']
         */
        get: function () { return this.getter('esri/symbols/PictureMarkerSymbol'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "SimpleLine", {
        /**
         * Get simple line symbol ['esri/symbols/simpleLine']
         */
        get: function () { return this.getter('esri/symbols/SimpleLineSymbol'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "SimpleFill", {
        /**
         * Get simple fill symbol ['esri/symbols/simpleFill']
         */
        get: function () { return this.getter('esri/symbols/SimpleFillSymbol'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "PictureFill", {
        /**
         * Get picture fill symbol ['esri/symbols/pictureFill']
         */
        get: function () { return this.getter('esri/symbols/PictureFillSymbol'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "TextSymbol", {
        /**
         * Get text symbol ['esri/symbols/textSymbol']
         */
        get: function () { return this.getter('esri/symbols/TextSymbol'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "Print", {
        /**
         * Get ESRI Simple Renderer ['esri/rest/print']
         */
        get: function () { return this.getter('esri/rest/print'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "PrintParameters", {
        /**
         * Get ESRI Simple Renderer ['esri/rest/support/PrintParameters']
         */
        get: function () { return this.getter('esri/rest/support/PrintParameters'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "PrintTemplate", {
        /**
         * Get ESRI Simple Renderer ['esri/rest/support/PrintTemplate']
         */
        get: function () { return this.getter('esri/rest/support/PrintTemplate'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "JsonUtils", {
        /**
         * Get ESRI JsonUtils ['esri/symbols/support/jsonUtils']
         */
        get: function () { return this.getter('esri/symbols/support/jsonUtils'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "SymbolUtils", {
        /**
         * Get ESRI SymbolUtils ['esri/symbols/support/symbolUtils']
         */
        get: function () { return this.getter('esri/symbols/support/symbolUtils'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "PromiseUtils", {
        /**
         * Get ESRI PromiseUtils ['esri/core/promiseUtils']
         */
        get: function () { return this.getter('esri/core/promiseUtils'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "watchUtils", {
        /**
         * Get ESRI watchUtils ['esri/core/watchUtils']
         */
        get: function () { return this.getter('esri/core/watchUtils'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "CoordinateWidget", {
        /**
         * Get ESRI Coordinate widget ['esri/widgets/CoordinateConversion']
         */
        get: function () { return this.getter('esri/widgets/CoordinateConversion'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "CoordinateWidgetViewModel", {
        /**
         * Get ESRI Coordinate widget view model ['esri/widgets/CoordinateConversion/CoordinateConversionViewModel']
         */
        get: function () { return this.getter('esri/widgets/CoordinateConversion/CoordinateConversionViewModel'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "CoordinateFormatter", {
        /**
         * Get ESRI Coordinate widget ['esri/geometry/coordinateFormatter']
         */
        get: function () { return this.getter('esri/geometry/coordinateFormatter'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "ScaleBarWidget", {
        /**
         * Get ESRI ScaleBar widget ['esri/widgets/ScaleBar']
         */
        get: function () { return this.getter('esri/widgets/ScaleBar'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "Format", {
        /*
         * Get ESRI Format ['esri/widgets/CoordinateConversion/support/Format']
         */
        get: function () { return this.getter('esri/widgets/CoordinateConversion/support/Format'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "GeodesicUtils", {
        /**
         * Get ESRI GeodesicUtils ['esri/geometry/support/geodesicUtils']
         */
        get: function () { return this.getter('esri/geometry/support/geodesicUtils'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "PortalItem", {
        /**
         * Get PortalItem ['esri/portal/PortalItem']
         */
        get: function () { return this.getter('esri/portal/PortalItem'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "MCLayer", {
        // Custom Classes
        get: function () { return LayerExtender.construct(); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "MCMap", {
        /**
         * Get MapCore Extended ESRI Map ['esri/Map']
         */
        get: function () { return MapExtender.construct(); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ESRI, "MCMapView", {
        /**
         * Get MapCore Extended ESRI Map View ['esri/views/MapView']
         */
        get: function () { return MapViewExtender.construct(); },
        enumerable: true,
        configurable: true
    });
    // End Getters
    ESRI.getter = function (moduleLocation) {
        var _this = this;
        return (function () { return tslib_1.__awaiter(_this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ESRI.loadModules(moduleLocation)];
                case 1: return [2 /*return*/, (_a.sent())[0]];
            }
        }); }); })();
    };
    return ESRI;
}());
export { ESRI };
